import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import smilIcon from '../assets/images/smile-solid.svg';
import filterIcon from '../assets/images/Filter-white.svg';
import resetFilterIcons from '../assets/images/Reset-Filter.svg';
import { checkIfMatchQueueFilterApplied } from '../helpers';
import AppConstants from '../appConstants';

const NoMatchQueueDataComponent = (props) => {
  const { showMatchQueueFilter = true, toggleFilterPopupVisibility = null, resetFilterHandler = null, handleClickProfile } = props;

  const location = useLocation();
  const history = useHistory();
  const { current } = useSelector((state) => state.user);
  const pageQueryParam = location.search.replace('?q=', '');
  const isMatchQueuePage = location.search === '' && location.hash === '';
  const isFilterApplied = checkIfMatchQueueFilterApplied(current);

  return (
    <div className="no-found-wrapper">
      <div className='filter2 text-right'>
        {
          showMatchQueueFilter && pageQueryParam === '' && (
            <>
              <div className='rightside'>
                <button type='button' className='filter' onClick={() => toggleFilterPopupVisibility(true)}>
                  match preferences <img className='ml-2' src={filterIcon} alt="/" />
                </button>
                {isFilterApplied && (
                  <button type='button' className='reseFilter' onClick={resetFilterHandler}>
                    <span className='icons'><img className='' src={resetFilterIcons} alt="reset filter" /></span>
                    <span className='reset'>Reset Filter</span>
                  </button>
                )}
              </div>
            </>
          )
        }
      </div>

      {isMatchQueuePage && (
        isFilterApplied
          ? <>
              <div className="title">
          <h1>No Matches Found</h1>
          <p>It seems no one fits your current Match Preferences just yet.</p>
          <p><span className='color-blue'>Please adjust your match preferences (desktop: top right <br/> corner, mobile: top
              left corner) to see potential matches.</span></p>
              <p>Keep exploring — your next great connection could be just <br/> a click away!
</p>
          <br /><br />
        
        </div>
          </>
          : <div className="title">
            <h1>Love is on the Way!</h1>

            <p>
              No matches yet. We are delighted you are here and we can’t <br />
              wait for you to meet the love of your life! <span className='color-blue'>Please adjust your <br />
              match preferences (desktop: top right corner, mobile: top <br />
              left corner) to see potential matches.</span>
            </p>
            <p>
              In the meantime, take a few minutes to spice up your profile <br />
              with the three steps below. It is the best way to up your <br />
              odds of getting a match. It is also a nice way to show your <br />
              matches that you care and they’ll appreciate that about <br />
              you...and your mama will be proud that you took her <br />
              &quot;make a good first impression&quot; lesson to heart. &nbsp;
              <img
                src={smilIcon}
                className="smaill-img"
                alt="smile-img"
              />
            </p>
            <ul className="list-unstyled pt-2">
              <li>
                <i
                  className={`fa fa-check ${current?.images &&
                    current?.images.length > 5 &&
                    'active'
                    }`}
                  aria-hidden="true"
                />
                <button
                  type="button"
                  className="btn addPhoto"
                  onClick={() => handleClickProfile('3')}
                >
                  Add Photos
                </button>
              </li>
              <li>
                <i
                  className={`fa fa-check ${current.hobbies && 'active'
                    }`}
                  aria-hidden="true"
                />
                <button
                  type="button"
                  className="btn addHobies"
                  onClick={() => handleClickProfile('0')}
                >
                  Add Hobbies
                </button>
              </li>
              <li>
                <i
                  className={`fa fa-check ${current.anual_income && 'active'
                    }`}
                  aria-hidden="true"
                />
                <button
                  type="button"
                  className="btn updateProfile"
                  onClick={() => handleClickProfile('0')}
                >
                  Update Profile
                </button>
              </li>
            </ul>
          </div>
      )
      }

      {!isMatchQueuePage && (
        <div className="title">
          <h1>No Results Found</h1>
          <p>It’s a little quiet here right now, as your search did not return<br /> any matching results.</p>
          <p>In the meantime, head over to the Discover tab to explore<br /> profiles, send roses, or like someone—your next connection<br /> could be waiting there!</p>
          <br /><br />
          <div>
            <button type="button" className="btn addPhoto" onClick={() => history.push(AppConstants.routes.afterLogin)}>Go to Discover</button>
          </div>
          <br />
          <div>
            <button type="button" className="btn addHobies" onClick={() => history.push(AppConstants.routes.publicProfile)}>Update Profile</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default NoMatchQueueDataComponent;
